import { Trans, useTranslation } from 'react-i18next';

import { AuthPageWrapper, AuthPageTitle, AuthSubPageTitle } from 'features/auth';
import { LinkW, SignUpHint } from 'features/auth/containers/SignInForm/styled';
import { Links } from 'settings';
import { AuthPageLink } from 'types';

import { RegisterCompanyForm } from '../../components';
import { useRegistrationPageLogic } from './hooks';

export function RegisterCompanyPage() {
  const { pageTitle, pageSubTitle, defaultValues, handleRegisterSubmit, isLoading, errors } =
    useRegistrationPageLogic();
  const { t } = useTranslation();

  return (
    <AuthPageWrapper link={AuthPageLink.signIn} isLoading={isLoading}>
      <AuthPageTitle>{pageTitle}</AuthPageTitle>
      <AuthSubPageTitle>{pageSubTitle}</AuthSubPageTitle>
      <RegisterCompanyForm
        defaultValues={defaultValues}
        handleRegisterSubmit={handleRegisterSubmit}
        errors={errors}
      />
      <SignUpHint>
        <Trans i18nKey="login.accountExist" values={{ linkLabel: t('login.signInBtn') }}>
          Already Registered?
          <LinkW to={Links.auth.signIn}>{t('login.signInBtn')}</LinkW>
        </Trans>
      </SignUpHint>
    </AuthPageWrapper>
  );
}
